import { render, staticRenderFns } from "./FormAlunoCadastro.vue?vue&type=template&id=1bf30d4d"
import script from "./FormAlunoCadastro.vue?vue&type=script&lang=js"
export * from "./FormAlunoCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports